<div class="addon-modal-bg" (click)="close()" @opacityInOut></div>
<div class="addon-modal" @scaleInOut>
  <i class="app-ico-mask app-ico-mask__x" (click)="close()"></i>

  <ng-container *ngIf="!showResult">
    <h2>{{ title }}</h2>
    <p class="description" [innerHTML]="description"></p>

    <div class="price" *ngIf="price">
      <span class="price-label">{{ 'AddOns.Price' | translate }}:</span>
      <span class="price-value">{{ 'USD' | currency }}{{ price }}</span>
    </div>

    <div class="is-error" *ngIf="error">
      {{ error }}
    </div>
  </ng-container>

  <ng-container *ngIf="showResult && success">
    <div class="success-message">
      <i class="app-ico-mask app-ico-mask__tick"></i>
      <h3>{{ 'Common.Success' | translate }}</h3>
      <p class="description" [innerHTML]="success"></p>
    </div>
  </ng-container>

  <div class="addon-modal__btns">
    <ng-container *ngIf="!showResult">
      <div class="is-btn is-btn__outfill" (click)="close()">
        {{ 'Common.Cancel' | translate }}
      </div>
      <div class="is-btn" [class.is-disabled]="isLoading" (click)="handleAction()">
        <span class="main-loader" *ngIf="isLoading"></span>
        <span>
          {{ getActionButtonText() | translate }}
        </span>
      </div>
    </ng-container>
    <ng-container *ngIf="showResult">
      <div class="is-btn" (click)="close()">
        {{ 'Common.Ok' | translate }}
      </div>
    </ng-container>
  </div>
</div>